<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-subway-station`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 5a1 1 0 00-1-1h-2a1 1 0 00-1 1v1h2C14.057 6 6 14.088 6 24.062c0 4.6 1.723 8.935 4.77 12.248l2.944-2.708-.25-.28A14.035 14.035 0 0110 24.062C10 16.294 16.27 10 24 10s14 6.294 14 14.062c0 3.606-1.354 6.993-3.75 9.579l2.934 2.718.284-.314A18.035 18.035 0 0042 24.062C42 14.125 34.002 6.06 24.11 6H26V5zm-9 24h5v11H7a1 1 0 00-1 1v2a1 1 0 001 1h34a1 1 0 001-1v-2a1 1 0 00-1-1H26V29h5a1 1 0 001-1v-2a1 1 0 00-1-1H17a1 1 0 00-1 1v2a1 1 0 001 1z"/></svg>
</template>
<script>

export default {
  name: 'IconSubwayStation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
